import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Outlet, useLocation } from 'react-router-dom';
import { EventEmitter } from '../../utils/EventEmitter';
import AppNavbar from './AppNavbar';
import AppSidebar from './AppSidebar';

const titlePrefix = window.__env.APP_TITLE_PREFIX || "Alida - ";

export default function AppLayout() {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);
  const [timestamp, setTimestamp] = useState(new Date().getTime());

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    EventEmitter.subscribe('update-timestamp', (ts: number) => setTimestamp(ts));
  }, []);

  return (
    <main className="app-root">
      <Helmet titleTemplate={`${titlePrefix}%s`}>
        <link rel="stylesheet" href={`${window.__env.OVERRIDES_CSS}?t=${timestamp}`} />
        <script src={`${window.__env.OVERRIDES_JS}?t=${timestamp}`} />
      </Helmet>

      {pathname === '/login'
        ? <Outlet />
        : (
          <>
            <AppNavbar showSidebar={handleShow} />
            <AppSidebar show={show} handleClose={handleClose} />

            <div className="full-viewport">
              <Outlet />
            </div>
          </>
        )}
    </main>
  )
}